import { render, staticRenderFns } from "./SpinButtons.vue?vue&type=template&id=2334d725&scoped=true&"
import script from "./SpinButtons.vue?vue&type=script&lang=js&"
export * from "./SpinButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334d725",
  null
  
)

export default component.exports